export function getUrl() {
  var url_string = window.location.href;
  var url = new URL(url_string);
  return url;
}

export function getLinkSite() {
  return process.env.NODE_ENV == "development"
    ? `http://homologacao.colaborador.com.br`
    : "https://www.coasul.com.br";
}

export function getLinkImpressao() {
  return process.env.NODE_ENV == "development"
    ? `http://homologacao.colaborador.com.br/impressao`
    : "https://www.coasul.com.br/colaborador/impressao";
}

export function dateFormat(data) {
  if(data == "") return ""
  var dataF = data.split("-");
  return `${dataF[2]}/${dataF[1]}/${dataF[0]}`;
}

export function dateUnformat(data) {
  var dataF = data.split("/");
  return `${dataF[2]}-${dataF[1]}-${dataF[0]}`;
}

export function getToken() {
  return sessionStorage.getItem("userKey");
}

export function getEstados() {
  let estados = require("@/assets/estados.json");
  return estados;
}

export function getCidades() {
  let cidades = require("@/assets/cidades.json");
  return cidades;
}

export const classCores = [
  "success",
  "info",
  "error",
  "primary",
  "other",
  "secondary",
  "warning",
  "danger",
];

export function formatMoeda(value, numDec = 2) {
  return value.toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: numDec,
  });
}

export const getMeses = [
  {
    mes: 1,
    descricao: "Janeiro",
  },
  {
    mes: 2,
    descricao: "Fevereiro",
  },
  {
    mes: 3,
    descricao: "Março",
  },
  {
    mes: 4,
    descricao: "Abril",
  },
  {
    mes: 5,
    descricao: "Maio",
  },
  {
    mes: 6,
    descricao: "Junho",
  },
  {
    mes: 7,
    descricao: "Julho",
  },
  {
    mes: 8,
    descricao: "Agosto",
  },
  {
    mes: 9,
    descricao: "Setembro",
  },
  {
    mes: 10,
    descricao: "Outubro",
  },
  {
    mes: 11,
    descricao: "Novembro",
  },
  {
    mes: 12,
    descricao: "Dezembro",
  },
];

export function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function(item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

export function removeAcento(text) {
  text = text.toLowerCase();
  text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
  text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
  text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
  text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
  text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
  text = text.replace(new RegExp("[Ç]", "gi"), "c");
  return text.toUpperCase();
}

export async function getCoordenadas() {
  return await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
}

export async function getBase64(file) {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  getUrl,
  dateFormat,
  getToken,
  classCores,
  formatMoeda,
  getLinkSite,
  getMeses,
  getEstados,
  getCidades,  
  findGetParameter,  
  removeAcento,
  getLinkImpressao,
  dateUnformat,
  getCoordenadas,
  getBase64,
};
